<template>
  <div class="lead-category-icon-container" :style="{ borderColor: color }">
    <div
      class="lead-category-icon-background"
      :style="{ backgroundColor: color, opacity: 0.1 }"
    ></div>
    <span class="pa-2" :style="{ fontSize: size, color: color }">
      {{ code }}
    </span>
  </div>
</template>
<script>
export default {
  name: "LeadCategoryIcon",
  props: {
    color: String,
    code: String,
    size: {
      type: String,
      default: "14px"
    }
  }
};
</script>

<style scoped>
.lead-category-icon-container {
  position: relative;
  width: fit-content;
  height: fit-content;
  border: 1px solid;
  border-radius: 4px;
}

.lead-category-icon-background {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
